import React, { useState, useEffect } from 'react';
import { checkRU, getRuPageSlug } from '../../index';
import RouteUrl from '../RouteEnum';
import axios from 'axios';

import MenuViewManager from '../CostMenu/MenuViewManager';
import Footer from '../PageComponents/Footer';
import Header from '../PageComponents/Header';
import ErrorWrapper from "../PageComponents/ErrorWrapper";

import "./Page.css";

const PriceListPage = () => {
    const { isRu, apiUrl } = checkRU();
    const [data, setData] = useState({});
    const [error, setError] = useState(false);
    const path = [{ link: "", title: isRu ? "Цены" : "Ціни" }];

    useEffect(() => {
        window.scrollTo(0, 0);
        axios.get(getRuPageSlug(RouteUrl.prices)).then(res => {
            setData(res.data);
        }).catch(err => setError(true));
    }, []);

    return (
        <ErrorWrapper error={error}>
            <Header path={path} data={data} />
            <h1 className="main-header">{data && data.title ? data.title.toUpperCase().split('|').join('\n') : ""}</h1>
            <div className="frame last">
                <MenuViewManager />
            </div>
            <Footer nested="1" />
        </ErrorWrapper>
    );
}

export default PriceListPage;